// engine
import { soundService, gsap } from '@aceroll/core';

// hacksaw
import { platformService } from '@aceroll/platform-hacksaw';

const SFX = {
	UI_BET: 'changing_bet',
	UI_SPIN: 'slot_spin'
};

const AMBIENTS = {
	LEVEL_1: 'level_0',
	LEVEL_2: 'level_1',
	LEVEL_3: 'level_1',
	LEVEL_4: 'level_1',
	BONUS: 'bonus-game-up',
	BONUS_SPLASH: 'bonus-game-0'
};

const betActions = {
	up: 'increase',
	down: 'decrease'
}

const betSoundSpriteName = 'bet_sounds';
let currentBetIndex;
let betsCount;

class GameSoundService {
	levelPlaying = false;
	currentAmbient = '';
	baseAmbient = AMBIENTS.LEVEL_1;

	#tween = gsap.timeline();

	constructor() {
		this.activeSound = '';
		this.baseAmbient = AMBIENTS.LEVEL_1;
	}

	initBetData(index, count) {
		currentBetIndex = index;
		betsCount = count;
	}

	fadeOutCurrentAmbient(duration) {
		soundService.fadeOut(this.currentAmbient, duration);
	}

	setBaseAmbient(duration) {
		this.currentAmbient = AMBIENTS.LEVEL_1;
		soundService.fadeIn(AMBIENTS.LEVEL_1, duration, 0.5);
	}

	setBonusSplashAmbient(duration) {
		this.currentAmbient = AMBIENTS.BONUS_SPLASH;
		soundService.fadeIn(AMBIENTS.BONUS_SPLASH, duration, 0.5);
	}

	setBonusAmbient(duration) {
		this.currentAmbient = AMBIENTS.BONUS;
		soundService.fadeIn(AMBIENTS.BONUS, duration, 0.5);
	}

	playLevelAmbient(level) {
		// ignore if in bonus game
		if (this.currentAmbient === AMBIENTS.BONUS) {
			return;
		}

		const DURATION_MS = 16000;
		this.#tween.clear();
		this.#tween.to({y:0}, {
			y: 0,
			duration: 0.001 * DURATION_MS,
			onComplete: () => {
				console.log('AMBIENT ENDED');
				this.levelPlaying = false;
				this.setBaseAmbient(400);
			}
		});

		const soundName = AMBIENTS[`LEVEL_${level}`];
		this.currentAmbient = soundName;

		if (!this.levelPlaying) {
			soundService.play(soundName);
		}

		this.levelPlaying = true;
		
	}

	processBetIndex(betAction, loop = false) {
		const up = betAction === betActions.up;
		currentBetIndex = up ? currentBetIndex + 1 : currentBetIndex - 1;

		if (currentBetIndex < 0) {
			if (loop) currentBetIndex = betsCount - 1;
			else currentBetIndex = 0;
		} else if (currentBetIndex >= betsCount) {
			if (loop) currentBetIndex = 0;
			else currentBetIndex = currentBetIndex = betsCount - 1;
		}
	}

	subscribeUISounds() {
		platformService.onUiBetChange((data) => {
			this.processBetIndex(data.action);
			const alias = `click${currentBetIndex}`;
			soundService.playFromSprite(betSoundSpriteName, alias);
		});

		platformService.onUiBetPlace(() => {
			soundService.play(SFX.UI_SPIN);
		});
	}
}

export const gameSoundService = new GameSoundService();
